module.exports = __webpack_public_path__ + "media/tracking/Jossue-b65bc94c.jpg";